<template>
  <div>
    <PageAllow controller="TakeTemplates" action="index" />
    <Breadcrumbs :items="items" />

    <v-slide-x-transition>
      <v-sheet class="transparent-background-color">
        <v-row dense class="mx-5">
          <v-col cols="12" sm="12" md="4">
            <v-row dense align="center" class="pa-1">
              <v-text-field
                v-model="templateNameSearch"
                :label="$t('TakeTemplates.Fields.template_name')"
                clearable
              ></v-text-field>
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="8" align-self="center">
            <v-row dense align="center">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="px-0 py-0 caption font-weight-bold grey--text"
                    color="primary"
                    @click.stop="getTemplatesFromAPI()"
                  >
                    <v-icon small class="pe-1">fa-search</v-icon>
                    {{ $t("Search.search") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.searchTip") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="caption font-weight-bold grey--text"
                    @click.stop="templateNameSearch = ''"
                  >
                    <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                    {{ $t("Search.reset") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.resetTip") }}</span>
              </v-tooltip>
              <v-spacer />
              <v-btn
                v-if="$permission.permissionAllow('TakeTemplates', 'add')"
                small
                color="primary"
                @click.stop="
                  currentItemMode = 'new';
                  currentItem = { id: 0 };
                "
                class="ms-1"
              >
                <v-icon x-small class="pe-1">fa-plus</v-icon>
                {{ $t("CRUD.newInfo", [$t("TakeTemplates.ObjectName")]) }}
              </v-btn>
              <!-- 新增普通盘点单 -->
            <v-btn
              v-if="$permission.permissionAllow('StockTakes', 'add')"
              small
              color="primary"
              class="ms-1"
              @click.stop="$router.push('/stock-takes/detail/regular-new')"
            >
              <v-icon x-small class="pe-1">fa-plus</v-icon>
              {{
                $t("CRUD.newInfo", [
                  $t("StockTakes.actions.regularStockTakeOrder"),
                ])
              }}
            </v-btn>
            </v-row>
          </v-col>
        </v-row>

        <div class="mx-4 mb-4">
          <v-data-table
            :headers="headers"
            :items="templates"
            :loading="loading"
            :search="templateNameSearch"
            multi-sort
            class="elevation-1 px-4 pt-1"
            :footer-props="$t('$config.footer-props')"
          >
            <template v-slot:header.material_setting="{ header }">
              {{ header.text }}
              <v-icon x-small>fa-sliders-h</v-icon>
            </template>
            <template v-slot:header.actions="{ header }">
              {{ header.text }}
              <v-icon x-small>fa-sliders-h</v-icon>
            </template>

            <template v-slot:item.material_setting="{ item }">
              <v-btn
                small
                color="info"
                dark
                class="px-2 me-2"
                :href="'/#/stock-takes/take-templates/' + (item && item.id ? item.id : 0)"
              >
                <v-icon x-small class="px-1">fa-align-left</v-icon>
                {{ $t("Opt.details") }}
              </v-btn>
              <v-btn
                small
                color="primary"
                dark
                class="px-2 me-2"
                :href="
                  '/#/stock-takes/take-templates/' + (item && item.id ? item.id : 0) + '/edit'
                "
              >
                <v-icon x-small class="px-1">fa-highlighter</v-icon>
                {{ $t("CRUD.update") }}
              </v-btn>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-tooltip
                top
                v-if="$permission.permissionAllow('TakeTemplates', 'edit')"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    small
                    v-bind="attrs"
                    v-on="on"
                    color="accent"
                    class="px-1 me-1"
                    @click.stop="
                      currentItemMode = 'edit';
                      currentItem = item;
                    "
                    >fa-pencil-alt
                  </v-icon>
                </template>
                <span>{{
                  $t("CRUD.editInfo", [$t("TakeTemplates.ObjectName")])
                }}</span>
              </v-tooltip>
              <v-tooltip top v-if="$permission.permissionAllow('TakeTemplates', 'delete')">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    small
                    v-bind="attrs"
                    v-on="on"
                    color="danger"
                    class="px-1 me-1"
                    @click.stop="
                      currentItem = item;
                      deleteDialog = true;
                    "
                    >fa-trash-alt
                  </v-icon>
                </template>
                <span>{{
                  $t("CRUD.deleteInfo", [$t("TakeTemplates.ObjectName")])
                }}</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </div>
      </v-sheet>
    </v-slide-x-transition>
    <Template
      v-model="currentItem"
      :mode="currentItemMode"
      @mode="currentItemMode = $event"
      @save="getTemplatesFromAPI()"
    />
    <DialogDelete
      v-model="deleteDialog"
      :label="$t('TakeTemplates.ObjectName')"
      @confirm="
        deleteTemplate();
        deleteDialog = false;
      "
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
// import consts from "@/consts";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import DialogDelete from "@/components/plugins/DialogDelete";
import TakeTemplates from "@/api/take_templates";
import Template from "./plugins/Template";


export default {
  components: {
    PageAllow,
    Breadcrumbs,
    DialogDelete,
    Template,
  },

  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.stockManagement"),
        disabled: false,
        href: "/current-stocks",
      },
      {
        text: i18n.t("Nav.stockTakes"),
        disabled: false,
        href: "/stock-takes",
      },
      {
        text: i18n.t("Nav.takeTemplates"),
        disabled: true,
        href: "/stock-takes/take-templates",
      },
    ],
    headers: () => [
      {
        text: i18n.t("TakeTemplates.Fields.template_name"),
        align: "start",
        sortable: true,
        filterable: true,
        value: "template_name",
      },
      {
        text: i18n.t("TakeTemplates.Fields.material_count"),
        align: "center",
        sortable: false,
        filterable: false,
        value: "material_count",
      },
      {
        text: i18n.t("TakeTemplates.Fields.material_setting"),
        align: "start",
        sortable: false,
        filterable: false,
        value: "material_setting",
      },
      {
        text: i18n.t("TableHeaders.actions"),
        align: "start",
        sortable: false,
        filterable: false,
        value: "actions",
      },
    ],

    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings"]),
  },

  mounted() {
    this.getTemplatesFromAPI();
  },

  data: () => ({
    templateNameSearch: "",
    templates: [],
    currentItem: null,
    currentItemMode: null,
    deleteDialog: false,
  }),

  methods: {
    getTemplatesFromAPI() {
      TakeTemplates.fetch().then(
        function (response) {
          if (response.data.status.isOK()) {
            this.templates = response.data.take_templates;
          }
        }.bind(this)
      );
    },
    deleteTemplate() {
      if (this.currentItem) {
        this.$store.dispatch("fullscreenLoading");
        TakeTemplates.del(this.currentItem.id).then(
          function (response) {
            if (response.data.status.isOK()) {
              this.getTemplatesFromAPI(); // 删除成功的话刷新数据
            }
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        );
      }
    },
  },

  beforeDestroy() {
    this.$store.dispatch("threadLoadingStopAll");
  },
};
</script>